import { render, staticRenderFns } from "./TaxonomyCompetitorsAdvanced.vue?vue&type=template&id=2662f292&"
import script from "./TaxonomyCompetitorsAdvanced.vue?vue&type=script&lang=js&"
export * from "./TaxonomyCompetitorsAdvanced.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports